// Theme-based related calculator groupings. If a slug appears in a group,
// its "Related Calculators" list will be seeded from that group first,
// then padded with same-category siblings up to 8 items.
export const THEMED_RELATED = {
  electronics: ['ohms-law', 'resistor', 'voltage-drop', 'wire-gauge', 'electricity'],
  chemistry:   ['molarity', 'molecular-weight', 'density', 'mass', 'weight-converter'],
  physics:     ['speed', 'density', 'horsepower', 'engine-horsepower', 'ohms-law'],
  time:        ['time', 'time-duration', 'time-zone', 'time-card', 'hours', 'date', 'day-counter', 'day-of-week', 'age', 'countdown'],
  fitness:     ['bmi', 'bmr', 'tdee', 'body-fat', 'ideal-weight', 'calorie', 'macro', 'protein'],
  home:        ['concrete', 'tile', 'mulch', 'gravel', 'square-footage', 'roofing', 'stair'],
  auto:        ['fuel-cost', 'gas-mileage', 'mileage', 'horsepower', 'engine-horsepower', 'auto-loan', 'tire-size'],
  weather:     ['wind-chill', 'heat-index', 'dew-point'],
  money:       ['loan', 'mortgage', 'refinance', 'amortization', 'compound-interest', 'apr', 'interest', 'tip'],
  tax:         ['income-tax', 'sales-tax', 'vat', 'take-home-pay', 'salary', 'marriage-tax', 'estate-tax'],
  retirement:  ['retirement', '401k', 'ira', 'roth-ira', 'social-security', 'pension', 'annuity'],
  string:      ['base64', 'url-encode-decode', 'password', 'binary', 'hex'],
  network:     ['ip-subnet', 'bandwidth', 'password'],
  academic:    ['gpa', 'grade', 'age'],
  chemistry2:  ['half-life', 'molarity', 'molecular-weight'],
  numeric:     ['roman-numeral', 'roman-numeral-date', 'binary', 'hex', 'scientific', 'fraction']
};

// Reverse lookup: slug → array of group names it belongs to
const REVERSE = (() => {
  const m = {};
  for (const [group, slugs] of Object.entries(THEMED_RELATED)) {
    for (const s of slugs) {
      (m[s] = m[s] || []).push(group);
    }
  }
  return m;
})();

// Returns the ordered list of related slugs for a given source slug
// (peers from the same theme groups, deduped and excluding the source).
export function getRelatedSlugs(slug) {
  const groups = REVERSE[slug] || [];
  const out = [];
  const seen = new Set([slug]);
  for (const g of groups) {
    for (const s of (THEMED_RELATED[g] || [])) {
      if (!seen.has(s)) { seen.add(s); out.push(s); }
    }
  }
  return out;
}
